module.exports = __webpack_public_path__ + "img/gift5-04-c1.58a77f31.png";